import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import type { DtwinConfigurationCreateContentResourceResponse } from "~/modules/dtwin/models/DtwinConfigurationCreateContentResourceResponse.interface";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export function useUploadDtwinConfiguration({
  organizationCode,
  dtwinUid,
}: {
  organizationCode?: number;
  dtwinUid: string;
}) {
  const error: Ref<LxcError | undefined> = ref();

  const isLoading = ref(false);

  const result: Ref<
    DtwinConfigurationCreateContentResourceResponse | undefined
  > = ref(undefined);

  async function uploadDtwinConfiguration(
    files: FileList,
    progress: Ref<number | undefined | null>,
  ) {
    isLoading.value = true;

    error.value = undefined;

    const response = await dtwinsService.uploadConfigurationFiles(
      Array.from(files),
      progress,
      dtwinUid,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    uploadDtwinConfiguration,
    error,
    isLoading,
    result,
  };
}
